import { TrashIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "antd";
import { Button } from "V2.0/common/button";

export default DeleteStepAction;

function DeleteStepAction(props) {
  const { onDeleteStep } = props;

  return (
    <Button
      plain
      onClick={(e) => {
        e.stopPropagation();
        onDeleteStep();
      }}
    >
      <Tooltip title="Delete">
        <TrashIcon className="size-4 text-gray-600" />
      </Tooltip>
    </Button>
  );
}
